import { Button } from '../../primitives/Button'
import { BrushCleaner } from '@/components/icons/BrushCleaner'

interface ClearFiltersButtonProps {
  /**
   * Callback when button is clicked
   */
  onClick: () => void
  /**
   * Whether the button should be visible
   * Typically based on whether any filters are active
   */
  visible?: boolean
  /**
   * Custom className
   */
  className?: string
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string
}

/**
 * ClearFiltersButton - Red button to clear all active filters
 *
 * Based on Figma design specifications:
 * - 36x36px square button
 * - Red background (#DC2626)
 * - Brush/Eraser icon
 * - Only visible when filters are active
 *
 * Usage:
 * ```tsx
 * <ClearFiltersButton
 *   onClick={handleClearAllFilters}
 *   visible={hasAnyActiveFilters}
 * />
 * ```
 */
export function ClearFiltersButton({
  onClick,
  visible = true,
  className,
  ariaLabel = 'Limpiar todos los filtros',
}: ClearFiltersButtonProps) {
  if (!visible) return null

  return (
    <Button
      aria-label={ariaLabel}
      className={`h-9 w-9 flex-shrink-0 bg-[#DC2626] p-0 hover:bg-[#B91C1C] active:bg-[#991B1B] ${className || ''}`}
      onClick={onClick}
      size="icon"
      variant="default"
    >
      <div className="flex h-4 w-4 items-center justify-center">
        <BrushCleaner className="h-4 w-4 text-[#FAFAFA]" />
      </div>
    </Button>
  )
}
